// extracted by extract-css-chunks-webpack-plugin
module.exports = {"offer-form":"offer-form___rtqAY","row":"row___1UReD","full":"full___1_44H","half":"half___3KvTl"};